import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import sImg1 from "../../images/story/image-left-1.jpg";
import sImg2 from "../../images/story/image-left-2.jpg";
import sImg3 from "../../images/story/image-left-3.jpg";

import srImg1 from "../../images/story/image-right-1.jpg";
import srImg2 from "../../images/story/image-right-2.jpg";
import srImg3 from "../../images/story/image-right-3.jpg";

gsap.registerPlugin(ScrollTrigger);

interface Story {
  id: string;
  date: string;
  sImg: string;
  srImg: string;
  title: string;
  description: string;
}

interface StorySection3Props {
  stClass?: string;
}

const Storys: Story[] = [
  {
    id: "01",
    date: "15 Feb 2025",
    sImg: sImg1,
    srImg: srImg1,
    title: "First Time We Met",
    description:
      "We met by chance at a coffee shop on a rainy afternoon. she was reading her favorite book, and I offered her the last available seat. What began as casual conversation quickly turned into hours of laughter neither of them expected.",
  },
  {
    id: "02",
    date: "10 May 2025",
    sImg: sImg2,
    srImg: srImg2,
    title: "Where Love Started",
    description:
      "We met by chance at a coffee shop on a rainy afternoon. she was reading her favorite book, and I offered her the last available seat. What began as casual conversation quickly turned into hours of laughter neither of them expected.",
  },
  {
    id: "03",
    date: "25 July 2025",
    sImg: sImg3,
    srImg: srImg3,
    title: "She Said Yes",
    description:
      "We met by chance at a coffee shop on a rainy afternoon. she was reading her favorite book, and I offered her the last available seat. What began as casual conversation quickly turned into hours of laughter neither of them expected.",
  },
];

const StorySection3: React.FC<StorySection3Props> = ({ stClass }) => {
  const storySlideRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const slideContainer = storySlideRef.current;
    if (!slideContainer) return;

    ScrollTrigger.getAll()
      .filter(
        (trigger) =>
          trigger.trigger instanceof HTMLElement &&
          trigger.trigger.classList.contains("story-slide")
      )
      .forEach((trigger) => trigger.kill());

    if (window.innerWidth <= 991) return;

    const sections = gsap.utils.toArray<HTMLElement>(
      ".story-item",
      slideContainer
    );
    if (!sections.length) return;

    const scrollTween = gsap.to(sections, {
      xPercent: -100 * (sections.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: slideContainer,
        pin: true,
        scrub: 0.2,
        snap: 1 / (sections.length - 1),
        end: () => "+=" + slideContainer.offsetWidth,
        onUpdate: (self) => {
          const progressBar = document.querySelector(".progress-bar");
          if (progressBar instanceof HTMLElement) {
            gsap.to(progressBar, { scaleX: self.progress, ease: "none" });
          }
        },
      },
    });

    return () => {
      scrollTween.scrollTrigger?.kill();
      ScrollTrigger.getAll()
        .filter(
          (trigger) =>
            trigger.trigger instanceof HTMLElement &&
            trigger.trigger.classList.contains("story-slide")
        )
        .forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <section className={`wpo-story-section-s3 ${stClass || ""}`}>
      <div className="container-fluid">
        <div className="story-wrap">
          <div className="story-slide" ref={storySlideRef}>
            {Storys.map((story, index) => (
              <div className="story-item" key={index}>
                <div className="image-left">
                  <img src={story.srImg} alt={story.title} />
                </div>
                <div className="story-crad">
                  <div className="story-title">
                    <h2>Our Love Story</h2>
                    <span>{story.id}</span>
                  </div>
                  <div className="story-content">
                    <div className="image-right">
                      <img src={story.sImg} alt={story.title} />
                    </div>
                    <div className="story-text">
                      <span>{story.date}</span>
                      <h2>{story.title}</h2>
                      <p>{story.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="progress-bar"></div>
    </section>
  );
};

export default StorySection3;
